import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "./layout/Layout";
import NotFound from "./pages/other/NotFound";
import TermsAndConditions from "./pages/other/TermsAndConditions";
import PrivacyPolicy from "./pages/other/PrivacyPolicy";
import CookiePolicy from "./pages/other/CookiePolicy";
import AwardsMemberships from "./components/AwardsMemberships";
import QualityCompliance from "./components/QualityCompliance";

// =========================
// Lazy Imports (Code-Splitting)
// =========================
const Index = lazy(() => import("./pages/Index"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const ProductPage = lazy(() => import("./pages/ProductPage"));
const BlogPage = lazy(() => import("./pages/BlogPage"));
const BlogDetails = lazy(() => import("./pages/blog-details"));
const GalleryPage = lazy(() => import("./pages/GalleryPage"));
const ProductCategoryPage = lazy(() => import("./pages/ProductCategoryPage"));
const ProductDetailPage = lazy(() => import("./pages/ProductDetailPage"));
const CertificatePage = lazy(() => import("./pages/CertificatePage"));

// =========================
// Auto scroll to top on page change
// =========================
function ScrollToTop() {
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
  return null;
}

// =========================
// Main App
// =========================
export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Layout>
        <Suspense fallback={<Loader />}>
          <Routes>
            {/* Home */}
            <Route path="/" element={<Index />} />

            {/* Static Routes */}
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/products" element={<ProductPage />} />
            <Route path="/blogs" element={<BlogPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            {/* <Route path="/contact" element={<Contact />} /> */}

            {/* Dynamic Product Pages */}
            <Route
              path="/products/:category"
              element={<ProductCategoryPage />}
            />
            <Route
              path="/products/:category/:product"
              element={<ProductDetailPage />}
            />
            {/* blog details  */}
            <Route path="/blog/:slug" element={<BlogDetails />} />

            {/* Certificate */}
            {/* <Route path="/certificates/:type" element={<CertificatePage />} /> */}
            <Route
              path="/awards-and-memberships"
              element={<AwardsMemberships />}
            />
            <Route
              path="/quality-and-compliance"
              element={<QualityCompliance />}
            />

            {/* other page */}
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookies-policy" element={<CookiePolicy />} />

            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Layout>
    </BrowserRouter>
  );
}

// =========================
// Loader Component (Fallback UI)
// =========================
function Loader() {
  return (
    <div style={loaderStyle}>
      <div className="spinner"></div>
      <p>Loading...</p>
    </div>
  );
}

const loaderStyle = {
  height: "70vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "18px",
  fontWeight: "600",
  color: "#ffb400",
};
